// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"64fb8cc7","193":"2b909eca","202":"7b8c1b12","453":"c61561b2","855":"775f7266"}[chunkId] + ".chunk.js";
};